import React, { useEffect, useState } from 'react';
import SelectionModal from '../../../../../src/stories/components/SelectionModal';
import { useDispatch, useSelector } from 'react-redux';
import { setDistrictByZoneId, setVillagesByBlockId, setWardsByUlbId } from '@store/actions/zoneDetailsActions';
const transformObject = (input: any) => {
    const result: any = {};
    for (const key in input) {
        if (Object.prototype.hasOwnProperty.call(input, key)) {
            result[key] = key;
        }
    }
    return result;
}


const VillagesDataModal = ({ setModal, formData, formState, labelName, setValue,value, allFormState, allFormData }: { labelName: string, formData: any, formState: any, setModal: (args: boolean) => void, setValue: (args: any) => void,value:any,allFormState:any, allFormData:any }) => {
    const [selectedVillage, setSelectedVillage] = useState<any>(formState?.value?value:'');
    const dispatch = useDispatch();
    const zoneByZoneId:any = useSelector((state:any)=>state.GeoNonGeoData.zoneByZoneId);
    const districtByState:any = useSelector((state:any)=>state.GeoNonGeoData.districtByState);
   

    const zoneId:any = useSelector((state:any)=>state.GeoNonGeoData.zoneId);
    const currentZone =zoneByZoneId?.[zoneId]?.[0];
    const stateId = currentZone?.st_id;
    
    const onSave = (selectedItems: any, show?: boolean, selectedItemsDetails?: any) => {
        
        setSelectedVillage(selectedItems);
        
        if (labelName === "Villages Mapped") {
            dispatch(setVillagesByBlockId(labelName, selectedItems));
            formState.value = selectedItems.map((item:any)=>item.village_name);
            formState.id = selectedItems.map((item:any)=>item.village_id);
            formState.code = selectedItems.map((item:any)=>item.village_code);
            formState.message = '';
            formState.isError = false;
            allFormState.wards_mapped.isError = false;
            allFormState.wards_mapped.message = '';
            if(selectedItems.length<=0 && allFormState?.wards_mapped?.value?.length <= 0){
                allFormData.wards_mapped['#required'] = true;
            }
            if(selectedItems.length<=0 && allFormState?.wards_mapped?.value?.length > 0){
                allFormData.wards_mapped['#required'] =true;
                allFormData.villages_mapped['#required'] =false;

            }
            if(selectedItems.length > 0 && allFormState?.wards_mapped?.value?.length <= 0){
                allFormData.wards_mapped['#required'] =false;
            }
            if(selectedItems.length > 0 && allFormState?.wards_mapped?.value?.length > 0){
                allFormData.wards_mapped['#required'] =true;
                allFormData.villages_mapped['#required'] =true;
            }
        }
        else if(labelName === "Wards Mapped")
        {
            dispatch(setVillagesByBlockId(labelName, selectedItems));
            formState.value = selectedItems.map((item:any)=>item.ward_name);
            formState.id = selectedItems.map((item:any)=>item.ward_id);
            formState.code = selectedItems.map((item:any)=>item.ward_code);
            formState.message = '';
            formState.isError = false;
            allFormState.villages_mapped.isError = false;
            allFormState.villages_mapped.message = '';
            if(selectedItems.length<=0 && allFormState?.villages_mapped?.value?.length <= 0){
                allFormData.villages_mapped['#required'] = true;
            }
            if(selectedItems.length<=0 && allFormState?.villages_mapped?.value?.length > 0){
                allFormData.villages_mapped['#required'] =true;
                allFormData.wards_mapped['#required'] =false;
            }
            if(selectedItems.length > 0 && allFormState?.villages_mapped?.value?.length <= 0){
                allFormData.villages_mapped['#required'] =false;
            }
            if(selectedItems.length > 0 && allFormState?.villages_mapped?.value?.length > 0){
                allFormData.villages_mapped['#required'] =true;
                allFormData.wards_mapped['#required'] =true;
            }
        }
        else if(labelName ==='District'){
            dispatch(setDistrictByZoneId(zoneId,selectedItems));
        }
        else {
            dispatch(setWardsByUlbId(labelName, selectedItems));
        }
        if(selectedItems.length){
            setValue(selectedItems);
        }
        else{
            setValue('');
        }
       
        setModal(false);
    }
    const data = transformObject(formData['#options']);
    
    const title = labelName.split(" ")[0];
    const districtsData=districtByState[stateId];
    // function findDuplicate() {
    // for (let i = 0; i < districtByState[stateId].length; i++) {
    //     if (districtByState[stateId][i].district_name ===formData['#options'][0].district_name ) {
    //       return true
    //     }
    //   }
    //   return false
    // }
//     const isDuplicate=findDuplicate()
//     if(labelName ==='District' 
//    && !isDuplicate
// ){
//     districtsData=districtByState[stateId];
//     formData['#options'].map((item:any)=>{
//         districtsData.push(item);
//     })
//     districtsData.sort(function(a:any, b:any){
//         const x = a.district_name.toLowerCase();
//         const y = b.district_name.toLowerCase();
//         if (x < y) {return -1;}
//         if (x > y) {return 1;}
//         return 0;
//       });
//     }
//     else{
//         districtsData=districtByState[stateId];
//     }

    return labelName === "District" ?
        <SelectionModal items={districtsData} onSave={onSave}
            title={`${title} Selected`}
            searchPlaceholder={`Search By ${title}`}
            selectedItemsProps={formData['#options']} />
        : <SelectionModal items={formData?.['#options'] ??[]} onSave={onSave}
            title={`${title} Selected`}
            searchPlaceholder={`Search By ${title}`}
            selectedItemsProps={selectedVillage!==""?selectedVillage:[]} />
};

export default VillagesDataModal;
